<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-transaction-type" class="modal absolute block w-5/6 sm:w-9/12 md:w-5/12 bg-white dark:bg-dark-800 shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Tipe Transaksi' : 'Tambah Tipe Transaksi'
          }}</h5>
      </div>
      <div id="modal-body" class="p-5">
        <InputTextCustom v-model="typeName" id="type-name" label="Nama Tipe" placeholder="Masukkan nama tipe transaksi"
          input_class="w-full" :valid="validation.name.valid" :error-message="validation.name.message" />
        <InputRadio v-model="needTable" id="need-table" name="need_table" label="Perlu Meja" :options="needOptions" :valid="validation.need_table.valid" :error-message="validation.need_table.message" />
        <InputRadio v-model="closeBill" id="close-bill" name="close_bill" label="Tutup Bill" :options="closeBillOptions" :valid="validation.close_bill.valid" :error-message="validation.close_bill.message" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-primary hover:bg-hover-primary text-white"
            @click="submitTransactionType" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputTextCustom from '../form/InputTextCustom.vue';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';
import InputRadio from '../form/InputRadio.vue';

export default {
  name: "ModalTransactionType",
  props: {
    transactionType: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom, InputRadio
  },
  data() {
    return {
      showModal: true,
      typeName: this.transactionType ? this.transactionType.name : '',
      needTable: this.transactionType ? this.transactionType.need_table : false,
      closeBill: this.transactionType ? this.transactionType.close_bill : false,
      isEdit: !!this.transactionType,
      needOptions: [
        { label: 'Ya', value: true, disabled: false },
        { label: 'Tidak', value: false, disabled: false }
      ],
      closeBillOptions:[
        { label: 'Ya', value: true, disabled: false },
        { label: 'Tidak', value: false, disabled: false }
    ],
      validation: {
        name: {
          valid: true,
          message: ''
        },
        need_table: {
          valid: true,
          message: ''
        },
        close_bill: {
          valid: true,
          message: ''
        }
      },
      field: ['name', 'need_table', 'close_bill'],
    }
  },
  watch: {
    transactionType(newVal) {
      if (newVal) {
        this.typeName = newVal.name;
        this.needTable = newVal.need_table;
        this.closeBill = newVal.close_bill;
        this.isEdit = true;
      } else {
        this.typeName = '';
        this.typeCode = '';
        this.needTable = false;
        this.closeBill = false;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('transaction_type', ['createTransactionType', 'updateTransactionType']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitTransactionType() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan tipe transaksi?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postTypeTransaction();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan tipe transaksi', life: 3000 });
        }
      });
    },
    async postTypeTransaction() {
      try {
        console.log(this.needTable, this.closeBill);
        const typeData = {
          name: this.typeName,
          need_table: this.needTable,
          close_bill: this.closeBill
        };

        if (this.isEdit && this.transactionType) {
          typeData.id = this.transactionType.id;
          await this.updateTransactionType(typeData);
        }
        else {
          await this.createTransactionType(typeData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Tipe Transaksi berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save transaction type:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>
